<template>
   <!-- <div class="sme-header"> -->
      <p class="sme-heading">FOS Xtreme Series</p>
      <p class="sme-heading-text">Select from a range of plans with <span>unlimited data usage</span>  and <span>free on-net calls</span> </p>
      <p class="sme-sub-heading">Increase Business Productivity</p>
      <!-- <div class="sme-header-button">
        <a href="/plan/fos-sme" class="sme-link">SME Broadband</a>
        <a href="/plan/fos-xtreme" class="xtreme-link"><span class="xtreme-text">Xtreme &nbsp;
          </span><span class="series-text"> Series </span></a>
      </div> -->
    <!-- </div> -->
</template>

<script>
    export default {
        
    }
</script>

<style scoped>
.sme-heading {
  font-size: 30px;
  font-weight: 700;
}
.sme-heading-text {
  color: #949DAB;
  font-weight: 400;
  font-size: 14px;
}
.sme-heading-text span {
  font-weight: 600;
}
.sme-sub-heading {
  font-weight: 500;
  color: #DA1919;
  font-size: 30px;
}
</style>